import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import css from "./NotificationsPopup.module.css";
import {
  selectNotificationsList,
  selectIsLoading,
} from "../../../redux/notifications/selectors.js";
import {
  markNotificationAsRead,
  markAllNotificationsAsRead,
  getNotificationById,
} from "../../../redux/notifications/operations.js";
import { useCan } from "../../../utils/permissions.js";

export default function NotificationsPopup() {
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotificationsList);
  const isLoading = useSelector(selectIsLoading);
  const [expandedId, setExpandedId] = useState(null);

  const can = useCan();

  const toggleExpand = (e, notification) => {
    e.stopPropagation();
    if (!notification.is_read) {
      dispatch(markNotificationAsRead(notification.id));
    }
    setExpandedId(prev => (prev === notification.id ? null : notification.id));
  };

  const handleNotificationClick = notification => {
    if (!notification.is_read) {
      dispatch(markNotificationAsRead(notification.id));
    }
    dispatch(getNotificationById(notification.id));
  };

  const handleMarkAll = () => {
    dispatch(markAllNotificationsAsRead());
  };

  const list = Array.isArray(notifications) ? notifications : [];

  const accessibleList = list.filter(
    notification =>
      can("notifications", "read") ||
      notification.type === "error" ||
      notification.type === "warning"
  );

  return (
    <div className={css.popup}>
      <div className={css.header}>
        <span className={css.title}>Сповіщення</span>
        <button
          className={css.markAllBtn}
          onClick={handleMarkAll}
          type="button"
        >
          Прочитати всі
        </button>
      </div>

      <div className={css.list}>
        {isLoading && list.length === 0 ? (
          <p className={css.empty}>Завантаження...</p>
        ) : list.length === 0 ? (
          <p className={css.empty}>Немає сповіщень</p>
        ) : accessibleList.length === 0 ? (
          <p className={css.empty}>У вас немає доступу до сповіщень</p>
        ) : (
          accessibleList.map(notification => {
            const isExpanded = expandedId === notification.id;

            const typeClass =
              notification.type === "error"
                ? css.itemError
                : notification.type === "warning"
                  ? css.itemWarning
                  : notification.type === "success"
                    ? css.itemSuccess
                    : "";

            return (
              <div
                key={notification.id}
                className={`${css.item} ${typeClass} ${
                  notification.is_read ? css.itemRead : css.itemUnread
                }`}
                onClick={() => handleNotificationClick(notification)}
              >
                {!notification.is_read && <span className={css.unreadDot} />}

                <div className={css.itemContent}>
                  <div className={css.itemHeader}>
                    <span className={css.itemTitle}>{notification.title}</span>

                    <button
                      className={css.expandBtn}
                      onClick={e => toggleExpand(e, notification)}
                      type="button"
                    >
                      {isExpanded ? <BsChevronUp /> : <BsChevronDown />}
                    </button>
                  </div>

                  {isExpanded ? (
                    <p className={css.messageExpanded}>
                      {notification.message}
                    </p>
                  ) : (
                    <p className={css.messageTruncated}>
                      {notification.message}
                    </p>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
